import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store/appStore";
import { EAppReducers } from "store/white-list";

const getState = (state: RootState) => state[EAppReducers.SCHEDULE];

export const scheduleSelector = createSelector(getState, (state) => state);
